import { useMessage } from "@hermes/intl";
import {
  ButtonV2,
  Select,
  usePrincipalColors,
  useScreenDetector,
} from "@hermes/ui";

import { useAppConfig } from "#internal/app/config/context";
import { LineCloseIcon } from "#internal/shared/ui/icons";

import type { DoctorsListParams } from "./types";

export const InsurancesFilter = ({
  params,
  onParamsChange,
  variant,
}: {
  params: DoctorsListParams;
  onParamsChange: (params: DoctorsListParams) => void;
  variant?: "filter-search" | "filter-outlined";
}) => {
  const principalColors = usePrincipalColors();
  const { isMobile, isDesktop } = useScreenDetector();
  const message = useMessage();
  const { insurances } = useAppConfig();

  return (
    <Select
      field={{
        value:
          insurances.find(({ id }) => Number(params.insurance) === id) ?? null,
        onChange: (selected) => {
          if ("value" in selected) {
            onParamsChange({
              sort: undefined,
              insurance: `${selected.value?.id}`,
            });
          } else {
            onParamsChange({
              insurance: undefined,
            });
          }
        },
      }}
      options={insurances.map((insurance) => ({
        label: insurance.name,
        value: insurance,
      }))}
      fontWeight="regular"
      mobile={{
        title: message({
          id: "1b37bfea-a8ef-4af1-a951-2e761223461c",
          default: "Insurance",
        }),
      }}
      children={(triggerRef, triggerProps) => {
        return (
          <ButtonV2
            text={
              insurances.find(({ id }) => Number(params.insurance) === id)
                ?.name ??
              message({ id: "1b37bfea-a8ef-4af1-a951-2e761223461c" })
            }
            variant={
              variant ? variant : isMobile ? "filter-search" : "filter-outlined"
            }
            active={!!params.insurance}
            triggerRef={triggerRef}
            triggerProps={triggerProps}
            icon={
              params.insurance ? (
                <LineCloseIcon
                  width={isMobile ? "20" : "24"}
                  height={isMobile ? "20" : "24"}
                  color={isMobile ? principalColors.white : principalColors.gs8}
                />
              ) : undefined
            }
            onIconPress={() => onParamsChange({ insurance: undefined })}
            {...(isDesktop ? { minWidth: 140 } : {})}
          />
        );
      }}
    />
  );
};
